import { ProfileSection } from "@/components/account/ProfileSection";
import { PasswordSection } from "@/components/account/PasswordSection";
import { TwoFactorSection } from "@/components/account/TwoFactorSection";
import { PreferencesSection } from "@/components/account/PreferencesSection";
import { DangerZoneSection } from "@/components/account/DangerZoneSection";

export default function AccountPage() {
  return (
    <div className="mx-auto w-full max-w-[640px] space-y-6 pb-12">
      <header>
        <h1 className="text-[28px] font-semibold tracking-tight text-slate-900">
          Account settings
        </h1>
        <p className="mt-1 text-sm text-slate-500">
          Manage your personal information and security
        </p>
      </header>

      <ProfileSection />
      <PasswordSection />
      <TwoFactorSection />
      <PreferencesSection />
      <DangerZoneSection />
    </div>
  );
}
